import { Pipe, PipeTransform } from '@angular/core';
import { CheckListItem } from './CheckListItem';

@Pipe({
  name: 'filterCheckListItem'
})
export class FilterCheckListItemPipe implements PipeTransform {

  transform(values: CheckListItem[], filterText): any[] {
    return filterText != undefined && filterText.length > 0 ? values.filter(v => v.label.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >= 0) : values;
  }

}